/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantCountResponse } from '../../models/merchant-count-response';

export interface GetCountOfMerchants$Params {
}

export function getCountOfMerchants(http: HttpClient, rootUrl: string, params?: GetCountOfMerchants$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantCountResponse>> {
  const rb = new RequestBuilder(rootUrl, getCountOfMerchants.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MerchantCountResponse>;
    })
  );
}

getCountOfMerchants.PATH = '/public/merchants_count';
